// import * as XLSX from 'xlsx';
// import { saveAs } from "file-saver";

// const generateXlsx = (data, header, title) => {
//     const ws = XLSX.utils.aoa_to_sheet([header]); // Create worksheet with header
//     XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true }); // Add data below header

//     // Set column widths to ensure full header is visible
//     const columnWidths = header.map(headerItem => ({ wch: headerItem.length + 5 })); // Adjust width based on header length
//     ws['!cols'] = columnWidths;

//     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true });
//     const finalData = new Blob([excelBuffer], { type: 'buffer' });

//     setTimeout(() => {
//         saveAs(finalData, `${title}.xlsx`);
//     }, 200);
// };

// export default generateXlsx;


import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

const MAX_CELL_LENGTH = 32767;

const trimCellValue = (value) => {
    if (typeof value === "string" && value.length > MAX_CELL_LENGTH) {
        return value.substring(0, MAX_CELL_LENGTH);
    }
    return value;
};

const sanitizeData = (data) => {
    return data.map(row => {
        const newRow = {};
        Object.keys(row).forEach(key => {
            newRow[key] = trimCellValue(row[key]);
        });
        return newRow;
    });
};

const generateXlsx = (data, header, title) => {

    const cleanData = sanitizeData(data);

    const ws = XLSX.utils.aoa_to_sheet([header]);

    XLSX.utils.sheet_add_json(ws, cleanData, {
        origin: 'A2',
        skipHeader: true
    });

    const columnWidths = header.map(h => ({ wch: h.length + 5 }));
    ws['!cols'] = columnWidths;

    const wb = {
        Sheets: { data: ws },
        SheetNames: ['data']
    };

    const excelBuffer = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
    });

    const finalData = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(finalData, `${title}.xlsx`);
};

export default generateXlsx;